import './PersonalInfo.scss';
import React from 'react';
import { history } from 'routes/history';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Vedacom from './Vedacom/Vedacom';
import CheckBox from '../../components/checkBox/checkBox';
import FullForm from '../Layouts/FullForm';
import { getDossier, loanRegister } from 'actions/aresActions';
import { BASE_PATH } from 'constants/index';
import { errorTag, recordEvent } from 'utilities/uTagging';
import { recordAndSavePage } from 'actions/errorViewNavigation';
import Password from './components/fields/password';
import { normalizeStringsSpain, alphabetRegExpByCountry } from 'utilities/logicByCountry';
import { SelectList } from 'components/SelectList/SelectList';
import { InputText } from 'components/inputText/inputText';
import { RadioButton } from 'components/RadioButton/RadioButton';
import validator from 'validator';
import optionsActions from 'actions/optionsActions';
import { actions as formActions } from 'react-redux-form';
import { formatText, getLanguage } from 'core/i18n';
import modalCancelActions from 'actions/modalCancelActions';
import preLoaderActions from 'actions/preLoaderActions';
import { PATH_ARES_LOAN } from 'constants/uTagConstants/paths';
import { ERROR_DOSSIER } from 'constants/analyticsErrors';
import { NIE } from '../commons/constants/userProfile';
import { COUNTRY_CODE_ES } from 'commonsConstants/countryCodes';
import { ReminderModal } from './Vedacom/ReminderModal';
import { isMobile } from 'utilities/browser';

class PersonalInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            continueEnabled: false,
            showPassword: false,
            passwordInputClass: 'password-number-input',
            iconPasswordClass: 'icon-pass-on show-password',
            requiredFields: {
                gender: false,
                nationality: false,
                birthCountry: false,
                birthProvince: false,
                birthPoblation: false,
                password: false,
                cirbeConsent: false,
                passport: false,
            },
            nonRequiredFields: ['vedacomConfirmedAcceptance'],
            displayPassReq: false,
            reminderModalOpen: false,
        };
    }

    async componentDidMount() {
        const { preLoaderActions, recordAndSavePage } = this.props;
        await this.getDossier();
        this.prepareOptions();
        recordAndSavePage(
            '/onboarding/completa-tus-datos-generales/',
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            'ares',
            {
                tipoPagina: 'generica',
                tipoProceso: 'onboarding',
                pasoProceso: 'completa-tus-datos-generales',
                tipoOnboarding: 'ares',
                productoOnboardingDetalle: 'prestamo ares',
                devId: '1personalInfo',
            }
        );
        preLoaderActions.hidePreLoader();
    }

    async getDossier() {
        const { formActions } = this.props;
        const urlQueryParams = new URLSearchParams(window.location.search);
        const callback = error => {
            errorTag(error.body, PATH_ARES_LOAN, ERROR_DOSSIER, error.statusCode);
            formActions.change('userProfile.dossierFailStatusCode', error.statusCode);
            history.push(`${BASE_PATH}/errors`);
        };
        if (urlQueryParams.get('dossier')) {
            await getDossier(
                formActions,
                callback,
                urlQueryParams.get('dossier'),
                urlQueryParams.get('accessToken')
            ).then(res => {
                const { documentType } = res.body;
                this.checkSpanish(documentType) && formActions.change('userProfile.nationality', 'ES');
            });
        } else {
            history.push(`${BASE_PATH}/errors`);
        }
    }

    isDNI(documentType) {
        return documentType.toLowerCase() === 'dni';
    }

    cities() {
        const { options } = this.props;

        return options.get('cities').toJSON();
    }

    countries() {
        const {
            options,
            userProfile: { documentType },
        } = this.props;
        const countries = options.get('countries').toJSON();

        return documentType === NIE ? countries.filter(option => option.value !== COUNTRY_CODE_ES) : countries;
    }

    getBirthCountries = () => {
        const {
            options,
            userProfile: { documentType },
        } = this.props;

        const countries = options.get('countries').toJSON();

        const getCountriesAndSortByOriginCountry = (acc, country) => {
            if (__ORIGIN_COUNTRY__ === country.value && documentType !== NIE) return [country, ...acc];

            return [...acc, country];
        };

        return countries.reduce(getCountriesAndSortByOriginCountry, []);
    };

    prepareOptions() {
        const { optionsActions } = this.props;
        optionsActions.getCountries();
        optionsActions.getProvinces();
    }

    handleTogglePassword = () => {
        const visiblePassword = this.state.showPassword;
        if (visiblePassword) {
            this.handleHidePassword();
        } else {
            this.handleShowPassword();
        }
        recordEvent(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
            accionEvento: 'nacionalidad',
            categoriaEvento: 'interaccion en datos personales',
            etiquetaEvento: visiblePassword ? 'ocultar' : 'mostrar',
        });
    };

    handleShowPassword = () => {
        this.setState({
            inputType: 'text',
            passwordInputClass: '',
            iconPasswordClass: 'icon-pass-off show-password-off',
            showPassword: true,
        });
    };

    handleHidePassword = () => {
        this.setState({
            inputType: 'tel',
            passwordInputClass: 'password-number-input',
            iconPasswordClass: 'icon-pass-on show-password',
            showPassword: false,
        });
    };

    checkEuropean(nationality) {
        const countriesList = this.countries();
        if (!countriesList || !nationality) return false;

        return !!countriesList.find(country => country.value === nationality).europeanUnion;
    }

    checkSpanish(documentType) {
        return this.isDNI(documentType);
    }

    handleFormOnChange = () => {
        const { userProfileForm, userProfile } = this.props;

        const requiredFields = Object.assign({}, this.state.requiredFields);
        const requiredFieldsKeys = Object.keys(requiredFields);

        for (const requiredFieldKey of requiredFieldsKeys) {
            if (userProfileForm[requiredFieldKey]) {
                requiredFields[requiredFieldKey] = userProfileForm[requiredFieldKey].valid;
            }
        }
        this.setState({
            requiredFields,
            continueEnabled: requiredFieldsKeys.every(key => {
                if (key === 'birthProvince' && userProfileForm['birthCountry'].value !== 'ES') {
                    return true;
                }
                if (key === 'passport' && !this.checkEuropean(userProfile.nationality)) {
                    return true;
                }
                if (userProfile['optionalVedacomCheck'] && !userProfile['vedacomConfirmedAcceptance']) {
                    return false;
                }
                if (!userProfile.cirbeConsent) {
                    return false;
                }

                return requiredFields[key];
            }),
        });
    };

    handleFormOnSubmit = async () => {
        const { userProfileForm, userProfile, dispatch, preLoaderActions } = this.props;

        const requiredFields = Object.assign({}, this.state.requiredFields);
        const requiredFieldsKeys = Object.keys(requiredFields);

        const values = {};

        requiredFieldsKeys.forEach(key => {
            if (key === 'birthProvince' && userProfileForm['birthCountry'].value !== 'ES') {
                return;
            }
            if (key === 'passport' && !this.checkEuropean(userProfile.nationality)) {
                return true;
            }
            values[key] = userProfileForm[key].value;
        });

        this.state.nonRequiredFields.forEach(key => {
            if (userProfileForm[key]) values[key] = userProfileForm[key].value;
        });

        const consents = [];
        Object.keys(values).forEach(key => {
            if (key === 'cirbeConsent') {
                consents.push({
                    acceptedText: formatText('field-cirbeConsent_ares'),
                    type: 'CIRBE',
                });
            }
            if (key === 'vedacomConfirmedAcceptance' && !!values[key]) {
                consents.push({
                    acceptedText: formatText('vedacon-text2_ares'),
                    type: 'VEDACON',
                });
            }
        });

        const bodyToSend = {
            birthCountry: values.birthCountry,
            birthPopulation: values.birthPoblation,
            consents,
            dossierId: userProfileForm['dossierId'].value,
            gender: values.gender,
            language: getLanguage(),
            nationality: values.nationality,
            password: values.password,
            ...(values.birthProvince && { birthProvince: values.birthProvince }),
            ...(values.passport && { passport: values.passport }),
        };

        preLoaderActions.showPreLoader();
        loanRegister(bodyToSend, dispatch);
    };

    closeReminderModal = () => this.setState({ reminderModalOpen: false });
    openReminderModal = () => this.setState({ reminderModalOpen: true });

    render() {
        const { userProfile, formActions, userProfileForm } = this.props;
        const { reminderModalOpen } = this.state;
        const isSpanish = this.checkSpanish(userProfile.documentType || '');

        return (
            <React.Fragment>
                <FullForm
                    className="ares personalinfo"
                    title={formatText('initial-complete')}
                    continueAction={() => {
                        recordEvent(
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            {
                                accionEvento: 'continuar',
                                categoriaEvento: 'interaccion en datos personales',
                                etiquetaEvento: `autorizacion consulta datos TGSS ${userProfile.optionalVedacomCheck} - autorizacion datos correctos ${userProfile.cirbeConsent}`,
                            }
                        );
                    }}
                    cancelAction={() => {
                        const { modalCancelActions } = this.props;
                        modalCancelActions.showModalCancel();
                        recordEvent(
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            {
                                accionEvento: 'salir',
                                categoriaEvento: 'interaccion en datos personales',
                            }
                        );
                    }}
                    hideRoadMapNavigation={false}
                    formModel="userProfile"
                    continueButtonEnabled={this.state.continueEnabled}
                    onChange={this.handleFormOnChange}
                    onSubmit={() => {
                        userProfile.vedacomConfirmedAcceptance ? this.handleFormOnSubmit() : this.openReminderModal();
                    }}
                >
                    <div className="row prospects-separator margin-0 prospects-gutter">
                        <div className="row md-form-group">
                            <div className="col-sm-6">
                                <RadioButton
                                    label={formatText('field-gender')}
                                    profileModel="userProfile.gender"
                                    optionsList={[
                                        {
                                            label: formatText('field-woman'),
                                            value: 'female',
                                        },
                                        {
                                            label: formatText('field-man'),
                                            value: 'male',
                                        },
                                    ]}
                                    isRequired
                                    disabled={false}
                                    messagesError={{ required: formatText('validation-radioRequired') }}
                                    style={{ margin: '0 0 -9px', color: '#002b45' }}
                                    onChange={() =>
                                        recordEvent(
                                            undefined,
                                            undefined,
                                            undefined,
                                            undefined,
                                            undefined,
                                            undefined,
                                            undefined,
                                            undefined,
                                            undefined,
                                            {
                                                accionEvento: 'sexo',
                                                categoriaEvento: 'interaccion en datos personales',
                                            }
                                        )
                                    }
                                    {...this.props}
                                />
                            </div>
                        </div>

                        <div className="row md-form-group">
                            <div className="col-sm-6">
                                <SelectList
                                    autofocus={false}
                                    profileModel="userProfile.nationality"
                                    name="country"
                                    optionsList={this.countries()}
                                    clearable={false}
                                    autoCompleteField={false}
                                    label={formatText('field-country')}
                                    placeholder={formatText('field-country')}
                                    validations={{
                                        required: value => {
                                            return value && value.length;
                                        },
                                    }}
                                    disabled={isSpanish}
                                    messagesError={{ required: formatText('validation-nationalityRequired') }}
                                    required
                                    searchable={true}
                                    isUpdated={function () {
                                        formActions.change('userProfile.nationality', userProfile.nationality);
                                    }}
                                    onChange={function (value) {
                                        formActions.change('userProfile.nationality', value);
                                        recordEvent(
                                            undefined,
                                            undefined,
                                            undefined,
                                            undefined,
                                            undefined,
                                            undefined,
                                            undefined,
                                            undefined,
                                            undefined,
                                            {
                                                accionEvento: 'nacionalidad',
                                                categoriaEvento: 'interaccion en datos personales',
                                            }
                                        );
                                    }}
                                    {...(isSpanish && { value: 'ES' })}
                                    {...this.props}
                                />
                            </div>
                        </div>

                        {!isSpanish && this.checkEuropean(userProfile.nationality) && (
                            <div className="row md-form-group">
                                <div className="col-sm-6">
                                    <InputText
                                        profileModel="userProfile.passport"
                                        label={formatText('field-passport')}
                                        type="text"
                                        name="birthPopulation"
                                        id="birthPopulation"
                                        pasteDisabled={false}
                                        autoCompleteField={false}
                                        validations={{
                                            required: value => value && value.length,
                                        }}
                                        messagesError={{
                                            required: formatText('validation-fieldRequired'),
                                        }}
                                        disabled={false}
                                        {...this.props}
                                    />
                                </div>
                            </div>
                        )}

                        <div className="row md-form-group">
                            <div className="col-sm-6">
                                <SelectList
                                    autofocus={false}
                                    profileModel="userProfile.birthCountry"
                                    name="birthCountry"
                                    optionsList={this.getBirthCountries()}
                                    clearable={false}
                                    autoCompleteField={false}
                                    label={formatText('field-birthCountry')}
                                    placeholder={formatText('field-birthCountry')}
                                    validations={{
                                        required: value => {
                                            return value && value.length;
                                        },
                                    }}
                                    messagesError={{ required: formatText('validation-birthCountryRequired') }}
                                    required
                                    searchable={true}
                                    isUpdated={function () {
                                        formActions.change('userProfile.birthCountry', userProfile.birthCountry);
                                    }}
                                    onChange={function (value) {
                                        formActions.change('userProfile.birthCountry', value);
                                        recordEvent(
                                            undefined,
                                            undefined,
                                            undefined,
                                            undefined,
                                            undefined,
                                            undefined,
                                            undefined,
                                            undefined,
                                            undefined,
                                            {
                                                accionEvento: 'pais de nacimiento',
                                                categoriaEvento: 'interaccion en datos personales',
                                            }
                                        );
                                    }}
                                    {...this.props}
                                />
                            </div>
                        </div>

                        {userProfile.birthCountry === 'ES' && (
                            <div className="row md-form-group">
                                <div className="col-sm-6">
                                    <SelectList
                                        autofocus={false}
                                        profileModel="userProfile.birthProvince"
                                        name="birthProvince"
                                        optionsList={this.cities()}
                                        clearable={false}
                                        autoCompleteField={false}
                                        label={formatText('field-birthProvince')}
                                        placeholder={formatText('field-birthProvince')}
                                        validations={{
                                            required: value => {
                                                return value && value.length;
                                            },
                                        }}
                                        messagesError={{ required: formatText('validation-provinceRequired') }}
                                        required
                                        searchable={true}
                                        isUpdated={function () {
                                            formActions.change('userProfile.birthProvince', userProfile.birthProvince);
                                        }}
                                        onChange={function (value) {
                                            formActions.change('userProfile.birthProvince', value);
                                            recordEvent(
                                                undefined,
                                                undefined,
                                                undefined,
                                                undefined,
                                                undefined,
                                                undefined,
                                                undefined,
                                                undefined,
                                                undefined,
                                                {
                                                    accionEvento: 'provincia de nacimiento',
                                                    categoriaEvento: 'interaccion en datos personales',
                                                }
                                            );
                                        }}
                                        {...this.props}
                                    />
                                </div>
                            </div>
                        )}

                        <div className="row md-form-group">
                            <div className="col-sm-6">
                                <InputText
                                    profileModel="userProfile.birthPoblation"
                                    label={formatText('field-birthPoblation')}
                                    placeholder={formatText('field-birthPoblation')}
                                    type="text"
                                    name="birthPopulation"
                                    id="birthPopulation"
                                    pasteDisabled={false}
                                    autoCompleteField={false}
                                    replaceFunction={normalizeStringsSpain}
                                    validations={{
                                        required: value => value && value.length,
                                        valid: value => validator.matches(value, alphabetRegExpByCountry()),
                                    }}
                                    messagesError={{
                                        required: formatText('validation-fieldRequired'),
                                        valid: formatText('validation-invalidBirthPoblation'),
                                    }}
                                    disabled={false}
                                    onFocus={() =>
                                        recordEvent(
                                            undefined,
                                            undefined,
                                            undefined,
                                            undefined,
                                            undefined,
                                            undefined,
                                            undefined,
                                            undefined,
                                            undefined,
                                            {
                                                accionEvento: 'poblacion de nacimiento',
                                                categoriaEvento: 'interaccion en datos personales',
                                            }
                                        )
                                    }
                                    {...this.props}
                                />
                            </div>
                        </div>
                        <Password
                            userProfileForm={userProfileForm}
                            userProfile={userProfile}
                            formActions={formActions}
                        />
                        <Vedacom
                            onChange={checked => {
                                if (!checked) {
                                    formActions.change('userProfile.vedacomConfirmedAcceptance', false);
                                }
                                recordEvent(
                                    undefined,
                                    undefined,
                                    undefined,
                                    undefined,
                                    undefined,
                                    undefined,
                                    undefined,
                                    undefined,
                                    undefined,
                                    {
                                        accionEvento: 'autorizacion consulta de datos TGSS checkbox',
                                        categoriaEvento: 'interaccion en datos personales',
                                        etiquetaEvento: checked ? 'checked' : 'unchecked',
                                    }
                                );
                            }}
                        />
                        <div className="row md-form-group">
                            <div className="col-sm-12">
                                <CheckBox
                                    profileModel="userProfile.cirbeConsent"
                                    checkBoxList={[
                                        {
                                            label: formatText('field-cirbeConsentTitle_ares'),
                                            model: 'userProfile.cirbeConsent',
                                        },
                                    ]}
                                    userProfile={userProfile}
                                    description={formatText('field-cirbeConsent_ares')}
                                    boldLabel={true}
                                    fieldsRequired="1"
                                    onChange={checked =>
                                        recordEvent(
                                            undefined,
                                            undefined,
                                            undefined,
                                            undefined,
                                            undefined,
                                            undefined,
                                            undefined,
                                            undefined,
                                            undefined,
                                            {
                                                accionEvento: 'autorizacion datos correctos',
                                                categoriaEvento: 'interaccion en datos personales',
                                                etiquetaEvento: checked ? 'checked' : 'unchecked',
                                            }
                                        )
                                    }
                                    {...this.props}
                                />
                            </div>
                        </div>
                    </div>
                </FullForm>
                <ReminderModal
                    isOpen={reminderModalOpen}
                    onConfirm={this.closeReminderModal}
                    onCancel={() => {
                        this.closeReminderModal();
                        this.handleFormOnSubmit();
                    }}
                    close={event => {
                        event.preventDefault();
                        this.closeReminderModal();
                    }}
                    title={formatText('messagesScreen-vedaconTitle')}
                    bodyText={formatText('messagesScreen-vedaconText')}
                    confirmText={formatText(`button-${isMobile() ? 'understood' : 'consents'}`)}
                    cancelText={formatText('button-uploadDocument')}
                />
            </React.Fragment>
        );
    }
}

export default connect(
    state => ({
        userProfile: state.userProfile,
        options: state.options,
        userProfileForm: state.userProfileForm,
    }),
    dispatch => ({
        dispatch,
        optionsActions: bindActionCreators(optionsActions, dispatch),
        formActions: bindActionCreators(formActions, dispatch),
        modalCancelActions: bindActionCreators(modalCancelActions, dispatch),
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
        recordAndSavePage: bindActionCreators(recordAndSavePage, dispatch),
    })
)(PersonalInfo);
